import { render } from "./SocialButtons.vue?vue&type=template&id=0a655822&scoped=true&ts=true"
import script from "./SocialButtons.vue?vue&type=script&lang=ts"
export * from "./SocialButtons.vue?vue&type=script&lang=ts"

import "./SocialButtons.vue?vue&type=style&index=0&id=0a655822&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a655822"]])

export default __exports__